/**
 * @author Harish.R <harish.r@314ecorp.com>
 * constants for workflows
 */

const REGISTRY_STATUS = {
	active: 'A' as Provider.IRegistryStatus,
	deactivated: 'IA' as Provider.IRegistryStatus,
};

const WORKFLOW_STATUS = {
	pending: 0 as Workflow.IStatus,
	running: 1 as Workflow.IStatus,
	completed: 2 as Workflow.IStatus,
	failed: 3 as Workflow.IStatus,
	paused: 4 as Workflow.IStatus,
};

export { WORKFLOW_STATUS, REGISTRY_STATUS };
